import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import sendPasswordResetEmail from '../../API/sendPasswordResetEmail';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState(''); // State for the message
  const [messageType, setMessageType] = useState(''); // State for message type ('success' or 'error')

  const handleFormSubmission = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const formValues = Object.fromEntries(formData.entries());
    
    // Call the API to send the reset email
    const result = await sendPasswordResetEmail(formValues.email);
    if (result.success) {
      setMessage('Reset instructions have been sent to your email.');
      setMessageType('success');
      setTimeout(() => {
        navigate('/login');
      }, 3000); // Redirect after 3 seconds
    } else {
      setMessage(`Failed to send reset instructions: ${result.message}`);
      setMessageType('error');
    }
  };

  return (
    <div className="forgot-password-container">
      <h2 className="forgot-password-title">Forgot Password</h2>
      <p className="forgot-password-description">
        Enter your email address and we'll send you instructions to reset your password.
      </p>
      <form onSubmit={handleFormSubmission} className="forgot-password-form">
        <div className="forgot-password-form-group">
          <input type="email" id="email" name="email" className="forgot-password-input" placeholder=" " required />
          <label htmlFor="email" className="forgot-password-label">Email</label>
        </div>
        <button type="submit" className="forgot-password-submit-btn">
          Send Reset Instructions
        </button>
      </form>
      {message && (
        <p className={`forgot-password-message ${messageType}`}>
          {message}
        </p>
      )}
      <div className="forgot-password-login-link">
        <button onClick={() => navigate('/login')} className="forgot-password-login-anchor">
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;
